import type { WheelConfig, WheelSegment } from '../../widgets/wheel/types';

/** Default 12-segment wheel with a long-tail multiplier distribution: ×1
 * dominates, ×25 jackpot is rare, two ✕ wedges keep the bankruptcy risk in
 * play without overshadowing the wins. */
export const DEFAULT_WHEEL_SEGMENTS: readonly WheelSegment[] = [
  { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0xffd23b, multiplier: 1, weight: 4 },
  { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0x42e2f5, multiplier: 2, weight: 3 },
  { id: 'x0-a', kind: 'multiplier', label: '✕', tint: 0x4a2055, multiplier: 0, weight: 2 },
  { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0xff6bd6, multiplier: 3, weight: 2 },
  { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0xffd23b, multiplier: 1, weight: 3 },
  { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xff8a3d, multiplier: 5, weight: 1 },
  { id: 'x0-b', kind: 'multiplier', label: '✕', tint: 0x4a2055, multiplier: 0, weight: 2 },
  { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0xfff59d, multiplier: 10, weight: 1 },
  { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0x42e2f5, multiplier: 2, weight: 3 },
  { id: 'x1-c', kind: 'multiplier', label: '×1', tint: 0xffd23b, multiplier: 1, weight: 3 },
  { id: 'x3-b', kind: 'multiplier', label: '×3', tint: 0xff6bd6, multiplier: 3, weight: 2 },
  { id: 'jackpot', kind: 'multiplier', label: '×25', tint: 0xff3b6b, multiplier: 25, weight: 1 },
];

export const DEFAULT_WHEEL_CONFIG: WheelConfig = {
  segments: DEFAULT_WHEEL_SEGMENTS,
  radius: 200,
  spinRotations: 5,
  spinDurationMs: 4200,
};
